import {THEME} from '@wandb/weave/common/css/color.styles';
import * as globals from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

import {Icon} from '../Icon';

export const ControlBar = styled.div`
  height: 1.7em;
  border-top: 1px solid light-dark(#ddd, var(--moon-750));
  background-color: ${THEME.bgPage};
  display: flex;
  justify-content: space-between;
`;

export const ArrowIcon: typeof Icon = styled(Icon)`
  cursor: pointer;
  height: 100%;
  padding: 4px 0px 0px 0px;
  :hover {
    color: ${globals.primary};
    background-color: light-dark(#eee, var(--moon-800));
    border-radius: 2px;
  }
  flex: 0 0 auto;
`;
